import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppEntities } from "src/config/entities";
import { StockTakingsDto } from "../dtos/StockTakingsDto";
import { IStockTakingsModel } from "../models/IStockTakingsModel";
import { StockTakingGoodsDto } from "../dtos/StocktakingGoodsDto";
import { StockTakingsService } from "src/services/documents/StockTakingsService";

interface IProps {
  documentId?: string;
}

export const useFetchStockTakings = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<StockTakingsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<IStockTakingsModel | null>(null);
  const dataService = AppEntities.StockTakings.getDataService() as StockTakingsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: IStockTakingsModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: StockTakingsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: StockTakingsDto | null = null;
      let responseStocktakingGoods: StockTakingGoodsDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: IStockTakingsModel = {
        ...responseDto,
        stocktakingGoods: [...responseStocktakingGoods]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
